import axiosInstance from "../Utils/axiosInstance";
import { BlockApi } from "../Constants/api";

export const getBlocksApi = async (params) => {
  try {
    const searchParams = new URLSearchParams(params);

    let response = await axiosInstance.get(
      `${BlockApi}?${searchParams.toString()}`
    );

    return response.data;
  } catch (error) {
    return error?.response?.data;
    // throw error; // Re-throw error for further handling if needed
  }
};
